const menu = $(".menu-drawer-container");
const openDetailsElement = $("details[open]");
const summaryElement = $(".menu-drawer-container[open]>summary");

if ($(window).width() < 480 || $(window).height() < 480) {
  $(".open-drawer").on("click", () => {
    menu
      .toggleClass("menu-opening")
      .promise()
      .done(() => {});
    menu.attr("open", "");
    summaryElement.attr("aria-expanded", true);
    document.body.classList.add("overflow-hidden-tablet");
    summaryElement.focus();
    $(".css-a2263j").css({
      display: "flex",
    });
  });

  $(".close-drawer").on("click", () => {
    $(".css-a2263j").css({
      display: "none",
    });
    document.body.classList.remove("overflow-hidden-tablet");
    document.body.classList.remove("overflow-hidden-mobile");
  });
}

$(".css-1fwmwm2 > p").click(function () {
  var openDrawerClass = $(this).toggleClass("css-lwv17d");
  var openDrawerFinalClass = $(this).attr("class");
  var icon = $(".header__icon--menu");
  menu
    .toggleClass("menu-opening")
    .promise()
    .done(() => {});
  menu.attr("open", "");
  icon.attr("aria-expanded", true);
  summaryElement.attr("aria-expanded", true);
  document.body.classList.add("overflow-hidden-tablet");
  summaryElement.focus();
  $(".css-a2263j").css({
    display: "flex",
  });
  $("." + openDrawerFinalClass).each(function () {
    $(this).attr("aria-expanded", true);
    $(this).parent().attr("open", "");
    $(this).parent().toggleClass("menu-opening");
  });
});

$(".open-search").on("click", () => {
  menu
    .toggleClass("menu-opening")
    .promise()
    .done(() => {});
  menu.attr("open", "");
  summaryElement.attr("aria-expanded", true);
  document.body.classList.add("overflow-hidden-tablet");
  summaryElement.focus();
  $(".css-a2263j").css({
    display: "flex",
  });
  $(".css-oawf44").focus();
});